import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import Import from "components/import-export/import"
import TenantContributionTable from './tenant-contributions-table'
// Data
import api_match from "data/interface/api"
import importService from "data/import"
import propertyService from 'data/property'
import reportTagService from 'data/report-tag'
import tenantContributionService from 'data/tenant-contributions'
import tenantGroupService from 'data/tenant-group'
import { alphanum } from "components/table/lib/sort"
//Styles
import { AddIcon } from "images/icons/tools"
import { TenantContributions_s } from './tenant-contributions-styles'

const TenantContributions: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [property, setProperty] = useState<object|null>(null);
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const [reportTags, setReportTags] = useState<object[]>([]);
  const [tenantGroups, setTenantGroups] = useState<object[]>([]);
  const tableId = "tenant-contributions-table"

  useEffect(() => {
    importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    toggleShowImport(false);

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        const currentProperty = _.find(data.value, {propertyid: data.current});
        setProperty(currentProperty);
      }
      switch (data.state) {
        case 'ok':
          setPropertyId(data.current)
          break
      }
    })

    const reportTagSubscription = reportTagService.stream().subscribe(data => {
      api_match(
        data,
        init  => setReportTags(init.value),
        ok    => {
          if(ok.value.length) { // sort only on first load
            setReportTags(ok.value)
          } else {
            setReportTags(ok.value)
          }
        },
        err   => {
          setReportTags(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const tenantGroupSubscription = tenantGroupService.stream().subscribe(data => {
      api_match(
        data,
        init  => setTenantGroups(init.value),
        ok    => {
          if(ok.value.length) { // sort only on first load
            setTenantGroups(ok.value)
          } else {
            setTenantGroups(ok.value)
          }
        },
        err   => {
          setTenantGroups(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const tenantContributionSubscription = tenantContributionService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          if(ok.value.length) { // sort only on first load
            setData(ok.value)
          } else {
            setData(ok.value)
          }
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    return function cleanup() {
      propertySubscription.unsubscribe()
      reportTagSubscription.unsubscribe()
      tenantContributionSubscription.unsubscribe()
      tenantGroupSubscription.unsubscribe()
    }
  }, [initSort])

  useEffect(() => {
    if (_.isNil(propertyId)) return
    propertyService.fetchProperty(propertyId)
    reportTagService.fetchReportTags(propertyId)
    tenantContributionService.fetchTenantContributions(propertyId)
    tenantGroupService.fetchTenantGroups(propertyId)
  }, [propertyId])

  const Add = () => {
    return (
      <a onClick={() => tenantContributionService.create(propertyService.getStoredPropertyId())}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  return (
    <TenantContributions_s>
      <Toolbar>
        <Add />
      </Toolbar>
      { showImport && <Import /> }
      { data && property && !showImport && reportTags && tenantGroups && <TenantContributionTable tableId={tableId} data={data} property={property} tenantGroups={tenantGroups} reportTags={reportTags} /> }
    </TenantContributions_s>
  )
}

export default TenantContributions
